var __TEMP__ = require('./identity.js');var identity = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_metaMap.js');var metaMap = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseSetData;
